export enum Apps {
    'Qwep' = 'qwep',
    'Admin Panel' = 'admin_panel',
    'Data' = 'crossdata',
    'UCS' = 'ucs',
}
